import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
  RESEARCHER,
  DOCTOR,
  PATIENT,
  SUPER_RESEARCHER,
  TECHNICIAN,
  ADMIN,
  SUPER_TECHNICIAN,
} from 'constants/userRoles';
import PatientHeader from 'containers/Header/PatientHeader';
import ResearcherHeader from 'containers/Header/ResearcherHeader';
import AdminHeader from 'containers/Header/AdminHeader';

import CommonHeader from './CommonHeader';
import DoctorHeader from './DoctorHeader';
import TechnicianHeader from './TechnicianHeader';

class Header extends PureComponent {
  static propTypes = {
    role: PropTypes.string,
    isAuthorized: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    role: null,
  };

  render() {
    const { role, isAuthorized } = this.props;
    if (isAuthorized) {
      switch (role) {
        case PATIENT:
          return <PatientHeader />;
        case DOCTOR:
          return <DoctorHeader />;
        case SUPER_TECHNICIAN:
        case TECHNICIAN:
          return <TechnicianHeader />;
        case SUPER_RESEARCHER:
        case RESEARCHER:
          return <ResearcherHeader />;
        case ADMIN:
          return <AdminHeader />;
        default:
          return <CommonHeader />;
      }
    } else {
      return <CommonHeader />;
    }
  }
}
export default Header;
